import React, { ReactNode } from 'react';
import { Box } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';

type LayoutProps = {
  children: ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
  return (
    <Box bgColor="gray-99" className={styles.layout}>
      <Box
        bgColor="white"
        maxWidth={54}
        mx="auto"
        minHeight="var(--layout-height)"
      >
        {children}
      </Box>
    </Box>
  );
};
